import React from 'react'
import '../Css/Course.css';


function ClientBanner() {
    return (
        <div className="Course-Wrapper">
            <div className="Course-Content">
                <div className="Course-Body-Context">
                    <img src={require('../Image/HREApp-Client.png')} style={{width:'600px',height:'95px'}} alt="下載維修王 iPhone App 預約家居維修"/>
                </div>        
            </div>
        </div>
    
  )
}

export default ClientBanner


